/**
 * EventDetail — one meeting, run by its organizer (§ G11).
 *
 * The roster panel is the same component the trip page mounts; it takes its
 * identity from the roster response, so it needs nothing from a trip here.
 */
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import OrganizerRosterPanel from '@/components/trips/OrganizerRosterPanel';
import EventAnchorForm from '@/components/trips/EventAnchorForm';
import EventOrganizersPanel from '@/components/trips/EventOrganizersPanel';

export default function EventDetail() {
  const { id } = useParams<{ id: string }>();
  if (!id) return null;

  return (
    <div className="mx-auto flex max-w-4xl flex-col gap-4 p-4">
      <Link to="/events" className="inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground">
        <ArrowLeft className="h-3 w-3" /> All meetings
      </Link>
      <EventAnchorForm groupId={id} />
      <EventOrganizersPanel groupId={id} />
      <OrganizerRosterPanel groupId={id} showAnchor={false} />
    </div>
  );
}
